import axios from "axios";

export const getDynamicMenuData = async (roleId, access_token) => {
  try {
    return await axios.get(
      `https://genesisspapi.augursapps.com/app/UIapi/PortalUserLoadingData?UserId=${roleId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    console.error("API Error:", err);
    throw err; // Rethrow error for better handling
  }
};
